/**
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import { DMI } from '../dmi';

// ----------------------------------------
// Inner data
// ----------------------------------------

// code

// ----------------------------------------
// Public
// ----------------------------------------

export const reInitScripts = ($container = $(document), awaitAll = true) => {
    return DMI.importAll($container, awaitAll);
};
